<template>
    
    <v-progress-linear
        indeterminate
        color="primary"
        class="mb-0"
    ></v-progress-linear>
    
</template>

<script setup>
</script>